import React, { useState } from "react";
import { LockKeyhole, RadioTower } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useStudioAuth } from "./StudioAuthContext";

const BANNER_IMG = "https://customer-assets-4nw71qhi.emergentagent.net/job_desk-custom/artifacts/dleu4wtz_IMG_6894.webp";

export const OperationsGate = ({ children }) => {
  const { unlocked, unlock } = useStudioAuth();
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (unlocked) return children;

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await unlock(pin);
      setPin("");
    } catch (_) {
      setError("Operator PIN not accepted");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#01020a] px-4 py-10 text-white">
      <div className="mx-auto grid min-h-[calc(100vh-5rem)] max-w-6xl place-items-center">
        <form onSubmit={submit} className="w-full max-w-md border border-white/10 bg-[#0a0c16]">
          <div className="relative h-20 overflow-hidden border-b border-white/10">
            <img src={BANNER_IMG} alt="Storm Desk" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-black/25" />
          </div>
          <div className="p-6 sm:p-8">
            <div className="flex items-center justify-between">
              <div className="grid h-10 w-10 place-items-center border border-blue-400/30 bg-blue-500/10">
                <LockKeyhole className="h-5 w-5 text-blue-300" />
              </div>
              <span className="mono flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
                <RadioTower className="h-3.5 w-3.5" /> Operator access
              </span>
            </div>
            <h1 className="display mt-5 text-3xl font-black uppercase">Storm Desk Operations</h1>
            <p className="mt-1 text-sm text-slate-400">Enter the operator PIN to open Studio controls.</p>
            <div className="mt-6">
              <Label htmlFor="operations-pin" className="mono text-[10px] uppercase tracking-[0.2em] text-slate-400">Operator PIN</Label>
              <Input
                id="operations-pin"
                data-testid="operations-pin-input"
                type="password"
                inputMode="numeric"
                maxLength={4}
                autoFocus
                value={pin}
                onChange={(event) => setPin(event.target.value.replace(/\D/g, "").slice(0, 4))}
                className="mono mt-2 h-12 rounded-none border-white/15 bg-black/40 text-center text-xl text-white tracking-[0.45em]"
              />
              {error && <p role="alert" data-testid="operations-pin-error" className="mono mt-2 text-xs text-red-400">{error}</p>}
            </div>
            <Button data-testid="operations-unlock-button" type="submit" disabled={busy || pin.length !== 4} className="mt-5 h-11 w-full rounded-none bg-blue-600 font-bold text-white hover:bg-blue-500">
              {busy ? "CHECKING…" : "UNLOCK STUDIO"}
            </Button>
            <p className="mono mt-4 text-center text-[10px] uppercase tracking-widest text-slate-600">Credentials required · Session memory only</p>
          </div>
        </form>
      </div>
    </main>
  );
};